import styled from 'styled-components';
import { Flex, type FlexProps } from '../../layout/Flex';

export const Row = styled(Flex)
    .withConfig({ displayName: 'Row' })
    .attrs((props) => ({
        py: 1,
        ...props,
        spacing: 1,
        width: '100%',
        direction: 'row',
        alignItems: 'center',
    }))`
    -webkit-user-drag: none;
    user-drag: none;
    -webkit-user-select: none;
    user-select: none;
    overflow: hidden;

    &:first-child {
        border-bottom: 1px solid var(--divider);
    }
`;

export const Column = styled(Flex)
    .withConfig({ displayName: 'Column' })
    .attrs<FlexProps>((props) => ({
        minWidth: 48,
        flexBasis: 0,
        flexShrink: 0,
        justifyContent: 'center',
        alignItems: props.alignItems,
    }))``;
